export default __webpack_public_path__ + "static/heroIcon2-0c6df221e2404bdc7cd8096daf6a02fc.svg";